module.exports = __webpack_public_path__ + "img/sport-event-campaign.fe2cecfe.jpg";